/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"

import Seo from "@components/seo"

import AppContext from "@src/context/appContext"
import classnames from "gpages/utils/classnames"
import * as styles from "./index.module.scss"

import { throttle } from "lodash"

import prepareImg from "@images/logo_background.png"
import { useBrowserLayout } from "gpages/hooks/layout"

import bgImg1 from "@images/bg/albums_background.png"
import bgImg2 from "@images/bg/cover_primaryvision.png"
import bgImg3 from "@images/bg/explore_interact_background.png"
import bgImg4 from "@images/bg/game_development_background.png"
import bgImg5 from "@images/bg/gpass_background.png"
import bgImg6 from "@images/bg/latenight_background.png"
import bgImg7 from "@images/bg/like_collect_background.png"
import bgImg8 from "@images/bg/listening_background.png"
import bgImg9 from "@images/bg/publish_background.png"
import bgImg10 from "@images/bg/registration_background.png"
import bgImg11 from "@images/bg/repeat_background.png"
import bgImg12 from "@images/bg/shopping_background.png"

const resourceImages = [
  bgImg1,
  bgImg2,
  bgImg3,
  bgImg4,
  bgImg5,
  bgImg6,
  bgImg7,
  bgImg8,
  bgImg9,
  bgImg10,
  bgImg11,
  bgImg12,
]

const dispatchNavEvent = throttle(
  (next) => {
    if (typeof next === "number") {
      window.dispatchEvent(new CustomEvent("setPage", { detail: next }))
    } else if (next) {
      window.dispatchEvent(new CustomEvent("next"))
    } else {
      window.dispatchEvent(new CustomEvent("back"))
    }
  },
  501,
  {
    trailing: false,
    leading: true,
  }
)

const dispatchShareEvent = () => {
  const SHARE_EVENT = new CustomEvent("share")
  window.dispatchEvent(SHARE_EVENT)
}
const Layout = ({ children, location }) => {
  const { isMobile, isWXBrowser, isNative } = useBrowserLayout()
  const [resourceLoaded, setResourceLoaded] = useState(false)

  // 加载资源，保证显示的时候基础字体和面板图片已经加载完毕
  useEffect(() => {
    if (resourceLoaded) {
      return
    }

    let loadedCount = 0
    let fontsLoaded = false
    const check = () => {
      if (loadedCount === resourceImages.length && fontsLoaded) {
        setResourceLoaded(true)
      }
    }

    // 图片加载
    const imgLoadEvent = () => {
      loadedCount += 1
      check()
    }
    for (const url of resourceImages) {
      const image = new Image()
      image.src = url
      image.style.visibility = "hidden"
      image.style.position = "absolute"
      image.style.top = "0px"
      image.style.left = "0px"
      image.style.transform = "translate(-200%, -200%)"
      image.onload = imgLoadEvent
      document.body.appendChild(image)
    }

    // 字体加载
    document.fonts.ready.then(function () {
      fontsLoaded = true
      check()
    })

    // 一段时间后强制显示
    setTimeout(() => {
      setResourceLoaded(true)
    }, 8000)
  }, [resourceLoaded])

  if (!resourceLoaded) {
    return (
      <div className={styles.mobileLayoutLoading}>
        <img src={prepareImg} alt="" />
      </div>
    )
  }

  return (
    <>
      <AppContext.Provider
        value={{
          isMobile,
          isWXBrowser,
          dispatchNavEvent,
          dispatchShareEvent,
          isNative,
        }}
      >
        <Seo />
        <div className={styles.mobileLayoutFullscreen}>
          <div className={classnames(styles.mobileLayoutContainer)}>
            {children}
          </div>
        </div>
      </AppContext.Provider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
